import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'

export default class extends Component {
  constructor(props) {
    super(props)

    this.state = {
      height: 0,
      select: null,
      isOpen: false,
      //name: ""//
    }

    this.handleClick = this.handleClick.bind(this)
    this.selectOption = this.selectOption.bind(this)
    this.removeOption = this.removeOption.bind(this)
  }

  handleClick(e) {
    //console.log('this.state', this.state)
    if (this.state.isOpen) {
      document.body.classList.add('hide-dropdown')
      setTimeout(() => {
        this.setState({ isOpen: false })
        document.body.classList.remove('hide-dropdown')
      }, 150)
    } else {
      this.setState({ isOpen: true }, () => {//console.log('Object.keys(this.props.items)', Object.keys(this.props.items).length * 18)
        this.setState({ height: Object.keys(this.props.items).lenght * 18//window.innerHeight - (this.body.getBoundingClientRect().top + this.body.getBoundingClientRect().height) 
        })
      })
    }
  }

  selectOption(e) {
    this.setState({ select: e.target.dataset.option.toString() }, () => {
      this.handleClick()
    })
    this.props.onSubmit(e.target.dataset.option.toString())
  }

  removeOption(e) {//нужно чтобы при нажатии, объект убирался
    this.setState({ select: undefined }, () => {
      //this.handleClick()
    })
    this.props.onSubmit(undefined)
  }

  componentDidMount() { }

  render() {
    const items = this.props.items
    const name = this.props.name
    const newclass = (this.props.class) ? this.props.class : "";
    //console.log('this.state.class', this.state.class)
    return (
      <div className={'Select ' + newclass}>
        <div className='Select-body' >

          {/*!this.state.select && (*/
            <span className='Select-icon'
              style={{
                transform: this.state.isOpen && 'rotate(-180deg)',
                transition: 'transform 200ms ease-out'
              }}
              onClick={this.handleClick} ref={el => { this.body = el }}
            >
              <svg xmlns='http://www.w3.org/2000/svg' width='41' height='24' viewBox='0 0 41 24'><path fill='#ff5027' fillRule='evenodd' d='M-.001 3.654l20.167 20.097L40.332 3.654 37.46.749 20.166 18 2.905.749z' /></svg>
            </span>
          /*)*/}
          {this.state.select && <button className='Select__submit Head'>→</button>}

          <span className='Select-label' onClick={this.handleClick} ref={el => { this.body = el }}>{name}</span>{/*this.state.select  items[this.state.select] Бренды*/}



          {this.state.select && <span className='Select-selected' onClick={this.removeOption}>
            <span className='Select-closeicon'>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">{/* x icon*/}
                <g id="close">
                  <path id="x" fill='#ff5027' d="M18.717 6.697l-1.414-1.414-5.303 5.303-5.303-5.303-1.414 1.414 5.303 5.303-5.303 5.303 1.414 1.414 5.303-5.303 5.303 5.303 1.414-1.414-5.303-5.303z" />
                </g>
              </svg>
            </span>
            {items[this.state.select]}</span>}
        </div>
        {this.state.isOpen &&
          <div className='Select-list' style={{ height: `${this.state.height}px` }}>
            <ul className='Select-scroll'>
              {Object.keys(items).map(key => (
                <li key={key} className='Select-item' onClick={this.selectOption} data-option={key}>{items[key]}</li>
              ))}
            </ul>
          </div>
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Select.jsx